import React from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Experience from "@/components/ui/Experience";
import Projects from '@/components/Projects';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import Stats from '@/components/Stats';
import Services from '@/components/Services';
import { ThemeProvider } from '@/components/ThemeProvider';
import { useIntersectionObserver } from '@/hooks/use-intersection-observer';
import SEOHead from '@/components/SEOHead';
import StructuredData from '@/components/StructuredData';

const Index = () => {
  const heroRef = useIntersectionObserver({ direction: 'up' });
  const statsRef = useIntersectionObserver({ direction: 'down' });
  const aboutRef = useIntersectionObserver({ direction: 'up' });
  const experienceRef = useIntersectionObserver({ direction: 'down' });
  const projectsRef = useIntersectionObserver({ direction: 'up' });
  const servicesRef = useIntersectionObserver({ direction: 'down' });
  const testimonialsRef = useIntersectionObserver({ direction: 'up' });
  const contactRef = useIntersectionObserver({ direction: 'down' });

  return (
    <>
      <SEOHead 
        title="Matthew Innes - Web Developer & Digital Designer Portfolio"
        description="Professional portfolio of Matthew Innes, specialising in web development, digital design, and UX/UI solutions. View live websites and digital projects."
        canonical="https://matthewweb.com"
      />
      <StructuredData
        type="website"
        title="Matthew Innes - Web Developer & Digital Designer Portfolio"
        description="Professional portfolio of Matthew Innes, specialising in web development, digital design, and UX/UI solutions."
        url="https://matthewweb.com"
        image="https://matthewweb.com/assets/images/profile-matthew.jpg"
        publishedTime="2025-01-01T00:00:00Z"
        modifiedTime={new Date().toISOString()}
      />
      <ThemeProvider>
        <div className="min-h-screen flex flex-col bg-background text-foreground dark:bg-navy dark:text-lightSlate">
          <Navbar />
          <main className="flex-grow">
            <div {...heroRef}><Hero /></div>
            
            {/* View Live Websites Image - Stretches side to side */}
            <div className="w-full bg-gradient-to-r from-slate-100 to-slate-200 dark:from-slate-800 dark:to-slate-900 py-16">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                  <h2 className="text-3xl md:text-4xl font-bold text-foreground dark:text-white mb-4">
                    View Live Websites
                  </h2>
                  <p className="text-lg text-foreground/80 dark:text-lightSlate max-w-2xl mx-auto">
                    Explore my portfolio of live websites and digital projects
                  </p>
                </div>
                <div className="w-full h-auto">
                  <img 
                    src="/assets/images/appsshowroomad.png" 
                    alt="Apps Showroom Advertisement" 
                    className="w-full h-auto object-cover rounded-lg shadow-2xl"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            
            <div {...statsRef}><Stats /></div>
            <div {...aboutRef}><About /></div>
            <div {...experienceRef}><Experience /></div>
            <div {...projectsRef}><Projects /></div>
            <div {...servicesRef}><Services /></div>
            <div {...testimonialsRef}><Testimonials /></div>
            <div {...contactRef}><Contact /></div>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </>
  );
};

export default Index;
